import { Route } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { DcsMetricsMonitoringComponent } from './metrics.component';

export const metricsRoute: Route = {
  path: 'dcs-metrics',
  component: DcsMetricsMonitoringComponent,
  data: {
    pageTitle: 'metrics.title'
  }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/metrics/metrics.route.ts